import config from '@/config';
import fetchWrapper from '@/services/fetchWrapper.service';

function getConfigurationGuests() {
  return fetchWrapper.get(`${config.apis.api.url}/configuration/guests`, {});
}

const GuestsService = {
  getConfigurationGuests
};

export default GuestsService;